import React, { useState } from "react";
import { Input } from "antd";
import {
  errorMsg,
  floatString,
  MAX_HR_PER_DAY,
  MIN_HR_PER_DAY,
  STRING_DATE,
} from "../../const/constant";
import dayjs from "dayjs";

interface NumericInputProps {
  inputkey: string;
  style?: React.CSSProperties;
  onBlur?: (key: string, value: string) => void;
  maxLength?: number;
  placeholder?: string;
  initinput?: string;
}

export default function NumericInput(props: NumericInputProps) {
  const { onBlur, inputkey, initinput } = props;

  const [value, setValue] = useState(initinput ? initinput : "");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const dateStr = `${inputkey.substring(0, 4)}-${inputkey.substring(4, 6)}-${inputkey.substring(6, 8)}`;
    const date = dayjs(dateStr).format(STRING_DATE);
    
    let { value: inputValue } = e.target;
    let decimals = 0;

    if (inputValue.length === 1 && inputValue === ".") {
      return;
    } else if (inputValue.length > 1 && inputValue.substring(0, 1) === ".") {
      inputValue = "0" + inputValue;
    }

    if (inputValue.includes(".")) {
      decimals = inputValue.toString().split(".")[1].length;
    }
    if (decimals > 2) {
      return;
    }

    const inputFloat = parseFloat(inputValue).toFixed(2);

    if (parseFloat(inputFloat) > MAX_HR_PER_DAY) {
      // errorMsg(`${date} has more than ${MAX_HR_PER_DAY} hours`);
      errorMsg(`You cannot input more than ${MAX_HR_PER_DAY} hours in a day.`);
      return;
    }
    if (parseFloat(inputFloat) < MIN_HR_PER_DAY) {
      errorMsg(`${date} has less than ${MIN_HR_PER_DAY} hour`);
      return;
    }

    const reg = /^\d*(\.\d*)?$/;
    if (reg.test(inputValue) || inputValue === "") {
      setValue(inputValue);
    }
  };

  // '.' at the end or only '-' in the input box.
  const handleBlur = () => {
    let valueTemp = value;
    if (value.charAt(value.length - 1) === "." || value === "-") {
      valueTemp = value.slice(0, -1);
    }
    let temp = valueTemp.replace(/0*(\d+)/, "$1");
    temp = floatString(temp, "String");
    setValue(temp);
    if (onBlur) onBlur(inputkey, temp);
  };

  return (
    <Input
      {...props}
      onChange={handleChange}
      onBlur={handleBlur}
      value={value}
    />
  );
}
